import { render, staticRenderFns } from "./GeolocationOptions.vue?vue&type=template&id=56ad7bed"
import script from "./GeolocationOptions.vue?vue&type=script&lang=js"
export * from "./GeolocationOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports